'use client'

import { ScrollToTop } from './scroll-to-top'
import { ReportIssueButton } from './report-issue-button'

/**
 * Bottom-right floating action stack. Back-to-Top sits on top (it fades in
 * past 300px of scroll); the Report-an-issue button sits directly below it
 * and is only rendered for logged-in users (`showReport`). This replaces the
 * standalone <ScrollToTop /> in the layouts so both buttons share one
 * positioned container and never overlap.
 */
export function FloatingActions({ showReport = false }: { showReport?: boolean }) {
  return (
    <div data-screenshot-exclude className="fixed bottom-6 right-1 z-50 flex flex-col items-end gap-3 sm:right-6">
      <ScrollToTop />
      {showReport && <ReportIssueButton />}
    </div>
  )
}
